// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body-inner {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-wpr {
  position: relative;
  flex: 1 0 0;
  height: calc(100vh - max(300px, 28.6vh));
  overflow: auto;
}
.content-wpr::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.content-wpr::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #aaa;
}
.content-wpr::-webkit-scrollbar-track {
  background: #ddd;
}

.date-time {
  top: 0;
  z-index: 1;
  width: 100%;
  width: 100%;
  color: #fff;
  display: flex;
  position: fixed;
  font-size: 24px;
  font-weight: bold;
  padding: 10px 25px;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.7);
}
.date-time .day-date {
  display: flex;
}
.date-time .day-date > *:not(:last-child) {
  border-right: 1px solid #fff;
  padding-right: 25px;
  margin-right: 25px;
}

.resetModalDescription {
  color: #777;
  font-weight: 500;
}

.infodialog p {
  font-size: 20px;
  line-height: 32px;
  font-weight: 500;
  color: #000;
}
.infodialog ::ng-deep .p-component-overlay-enter {
  animation: none;
  transition-duration: unset;
  transition: 0.01s ease;
}
.infodialog ::ng-deep .p-dialog-top .p-dialog {
  margin: 0 !important;
}

.round-dialog ::ng-deep .p-dialog {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  backdrop-filter: blur(5px);
  padding: 33px 30px;
}
.round-dialog ::ng-deep .p-dialog-header,
.round-dialog ::ng-deep .p-dialog-content,
.round-dialog ::ng-deep .p-dialog-footer {
  background-color: transparent;
  border: none;
  padding: 0px;
}
.round-dialog ::ng-deep .p-dialog-header {
  justify-content: flex-start;
  gap: 30px;
}
.round-dialog ::ng-deep .p-dialog-header span {
  color: #000;
  font-size: 18px;
  font-weight: 700;
  display: block;
  margin-bottom: 10px;
  text-transform: uppercase;
  line-height: 40px;
}
.round-dialog ::ng-deep .p-dialog-header-close {
  display: none;
}
.round-dialog ::ng-deep .p-dialog-footer {
  padding-top: 25px;
}
.round-dialog ::ng-deep .p-dialog-footer .p-button.theme-button {
  border-radius: 30px;
  padding: 15px 40px 12px;
  font-size: 20px;
  line-height: 1;
}
.round-dialog ::ng-deep .p-dialog-footer .p-button.p-button-text {
  color: #777;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  margin-right: 20px;
  background: transparent !important;
}

.reset-dialog ::ng-deep .p-dialog-header {
  margin-bottom: 25px;
}
.reset-dialog ::ng-deep .p-dialog-header .timer {
  color: #000;
  font-size: 50px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 0px;
  line-height: 40px;
}

::ng-deep .center-dialog {
  transform: translateY(-50%) !important;
  top: calc(50% + max(300px, 28.6vh) / 2);
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./projects/clientside/src/app/app.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,wCAAA;EACA,cAAA;AAAF;AACE;EACE,UAAA;EACA,WAAA;AACJ;AACE;EACE,kBAAA;EACA,gBAAA;AACJ;AACE;EACE,gBAAA;AACJ;;AAMA;EACE,MAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,oCAAA;AAHF;AAIE;EACE,aAAA;AAFJ;AAGI;EACE,4BAAA;EACA,mBAAA;EACA,kBAAA;AADN;;AAMA;EACE,WAAA;EACA,gBAAA;AAHF;;AAOE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAJJ;AAME;EACE,eAAA;EACA,0BAAA;EACA,sBAAA;AAJJ;AAME;EACE,oBAAA;AAJJ;;AASE;EACE,0CAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AANJ;AAQE;;;EAGE,6BAAA;EACA,YAAA;EACA,YAAA;AANJ;AAQE;EACE,2BAAA;EACA,SAAA;AANJ;AAQI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AANN;AASE;EACE,aAAA;AAPJ;AASE;EACE,iBAAA;AAPJ;AAQI;EACE,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AANN;AAQI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kCAAA;AANN;;AAWE;EACE,mBAAA;AARJ;AASI;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAPN;;AAYA;EACE,sCAAA;EACA,uCAAA;EACA,oBAAA;AATF","sourcesContent":["@import '../variable';\n\n.body-inner {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n.content-wpr {\n  position: relative;\n  flex: 1 0 0;\n  height: calc(100vh - max(300px, $image_height));\n  overflow: auto;\n  &::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n  }\n  &::-webkit-scrollbar-thumb {\n    border-radius: 5px;\n    background: #aaa;\n  }\n  &::-webkit-scrollbar-track {\n    background: #ddd;\n  }\n}\n// .mappedin-ad-wpr {\n//     padding-top: min(390px, 36.11%);\n//     position: relative;\n// }\n.date-time {\n  top: 0;\n  z-index: 1;\n  width: 100%;\n  width: 100%;\n  color: #fff;\n  display: flex;\n  position: fixed;\n  font-size: 24px;\n  font-weight: bold;\n  padding: 10px 25px;\n  justify-content: space-between;\n  background-color: rgba($color: #000000, $alpha: 0.7);\n  .day-date {\n    display: flex;\n    & > *:not(:last-child) {\n      border-right: 1px solid #fff;\n      padding-right: 25px;\n      margin-right: 25px;\n    }\n  }\n}\n\n.resetModalDescription {\n  color: #777;\n  font-weight: 500;\n}\n\n.infodialog {\n  p {\n    font-size: 20px;\n    line-height: 32px;\n    font-weight: 500;\n    color: #000;\n  }\n  ::ng-deep .p-component-overlay-enter {\n    animation: none;\n    transition-duration: unset;\n    transition: 0.01s ease;\n  }\n  ::ng-deep .p-dialog-top .p-dialog {\n    margin: 0 !important;\n  }\n}\n\n.round-dialog ::ng-deep {\n  .p-dialog {\n    background-color: rgb(255 255 255 / 80%);\n    border-radius: 20px;\n    backdrop-filter: blur(5px);\n    padding: 33px 30px;\n  }\n  .p-dialog-header,\n  .p-dialog-content,\n  .p-dialog-footer {\n    background-color: transparent;\n    border: none;\n    padding: 0px;\n  }\n  .p-dialog-header {\n    justify-content: flex-start;\n    gap: 30px;\n\n    span {\n      color: #000;\n      font-size: 18px;\n      font-weight: 700;\n      display: block;\n      margin-bottom: 10px;\n      text-transform: uppercase;\n      line-height: 40px;\n    }\n  }\n  .p-dialog-header-close {\n    display: none;\n  }\n  .p-dialog-footer {\n    padding-top: 25px;\n    .p-button.theme-button {\n      border-radius: 30px;\n      padding: 15px 40px 12px;\n      font-size: 20px;\n      line-height: 1;\n    }\n    .p-button.p-button-text {\n      color: #777;\n      font-size: 20px;\n      font-weight: 700;\n      text-transform: uppercase;\n      margin-right: 20px;\n      background: transparent !important;\n    }\n  }\n}\n.reset-dialog ::ng-deep {\n  .p-dialog-header {\n    margin-bottom: 25px;\n    .timer {\n      color: #000;\n      font-size: 50px;\n      font-style: normal;\n      font-weight: 400;\n      margin-bottom: 0px;\n      line-height: 40px;\n    }\n  }\n}\n\n::ng-deep .center-dialog {\n  transform: translateY(-50%) !important;\n  top: calc(50% + calc(max(300px, 28.6vh) / 2));\n  margin: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
